<div class="input-content">
    <nb-tabset (changeTab)="tabChanged($event)">
        <nb-tab tabTitle={{defaultInputMenuItem}}>
            <kve-colours></kve-colours>
        </nb-tab>
        <nb-tab tabTitle="Typography">
            <kve-typography></kve-typography>
        </nb-tab>
    </nb-tabset>
    <!-- <div class="active-menu-item">{{defaultInputMenuItem}}</div> -->
    
</div>
